/**
 * import Vue
 * ※vueを使用しない場合は削除する
 */
import App from './vue/App.js';

/**
 * import node_modules
 */
import 'desvg';
import objectFitImages from 'object-fit-images';
import picturefill from 'picturefill';
import SmoothScroll from 'smooth-scroll';
/**
 * import modules
 */
import Nav from './modules/nav';
import Common from './modules/common';
import Top from './modules/top';
import Qa from './modules/qa';
import Adgallery from './modules/adgallery';
import AlphaCharge from './modules/alphaCharge';
import Informed from './modules/informed';
import Healing from './modules/healing';
import Drink from './modules/drink';
import Product from './modules/product'
import InView from './modules/in_view';
import IclearCharge from './modules/iclearCharge';


const target = $('main').attr('id');
switch (target) {
  case 'top':
    const top = new Top();
    top.init();
    break;
  case 'qa':
    const qa = new Qa();
    qa.init();
    break;
  case 'adgallery':
    const adgallery = new Adgallery();
    adgallery.init();
    break;
  case 'alphaCharge':
    const alphaCharge = new AlphaCharge();
    alphaCharge.init();
    break;
  case 'informed':
    const informed = new Informed();
    informed.init();
    break;
  case 'drink':
    const drink = new Drink();
    drink.init();
    break;
  case 'product':
    const product = new Product();
    product.init();
    break;
  case 'iclearCharge':
    const iclearCharge = new IclearCharge();
    iclearCharge.init();
    break;
}


/**
 * Mainクラス
 * @constructor
 */
class Main {
  constructor() {
    this.setup();
  }
  /**
   * インスタンス生成時に実行する処理
   */
  setup() {
    document.addEventListener('DOMContentLoaded', () => {
      this.created();

    })
    window.addEventListener('load', () => {
      this.mounted();
    });
  }
  /**
   * ページ読み込み時に実行する処理
   */
  created() {
    picturefill();

    const nav = new Nav();
    nav.init();

    const common = new Common();
    common.init();

    const healing = new Healing();
    healing.init();

    const inView = new InView();

  }
  /**
   * 画像読み込み後に実行する処理
   */
  mounted() {


    this.init_deSVG('.js-desvg');

    this.init_objectFitImages('.object-fit');

    this.init_smoothScroll();
  }



  /**
   * ライブラリ/deSVG
   * インラインsvgをsvgタグに変換
   * https://github.com/benhowdle89/deSVG
   * @param {Element} target ターゲットとなる要素
   */
  init_deSVG(target) {
    deSVG(target, true)
  }

  /**
   * ライブラリ/object-fit-images
   * css object-fit のポリフィル
   * https://github.com/fregante/object-fit-images
   * @param {Element} target ターゲットとなる要素
   */
  init_objectFitImages(target) {
    objectFitImages(target);
  }

  /**
   * ライブラリ/picturefill
   * html pictureタグのポリフィル
   * https://scottjehl.github.io/picturefill/
   */
  init_picturefill() {
    picturefill();
  }

  /**
   * ライブラリ/smooth-scroll
   * スムーススクロール
   * https://github.com/cferdinandi/smooth-scroll
   */
  init_smoothScroll() {
    /**
     * ターゲットとなる要素
     * @type {Element}
     */
    const targetElement = 'a[href*="#"]';

    /**
     * オプション
     * @type {object}
     */
    const option = {
      speed: 1000,
      easing: 'easeInOutCubic',
      speedAsDuration: true,
      //header: '.l-header' 固定ヘッダーの場合
    }

    new SmoothScroll(targetElement, option);
  }
}

export default new Main();
